import { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import styles from './introduction.module.scss';

const Introduction = ({ scrollRef }) => {
  const [load, setLoad] = useState(false);
  const [firstLoad, setFirstLoad] = useState(false);
  const [secondLoad, setSecondLoad] = useState(false);
  const [viewRef, inView] = useInView();

  useEffect(() => {
    if (inView) {
      setTimeout(() => {
        setLoad(true);
      }, 100);

      setTimeout(() => {
        setFirstLoad(true);
      }, 500);

      setTimeout(() => {
        setSecondLoad(true);
      }, 900);

      return () => {
        setLoad(false);
        setFirstLoad(false);
        setSecondLoad(false);
      };
    }
  }, [inView]);

  return (
    <>
      <div className={styles.container}>
        <section className={styles.introSection} ref={viewRef}>
          <div
            className={`${styles.yLine} ${styles.line} ${
              load ? styles.load : ''
            }`}
          ></div>
          <div className={styles.introWrapper}>
            <div className={styles.title}>
              <div
                className={`${styles.cycle} ${
                  secondLoad ? styles.slideDownLoad : ''
                }`}
              ></div>
              <div
                className={`${styles.shadow} ${
                  secondLoad ? styles.slideDownLoad : ''
                }`}
              ></div>
              <p
                className={`${styles.slideText} ${styles.slideDown} ${
                  firstLoad ? styles.slideDownLoad : ''
                }`}
              >
                Hello
              </p>
              <p
                className={`${styles.fadeText}  ${styles.fade} ${
                  firstLoad ? styles.fadeLoad : ''
                }`}
              >
                안녕하세요! <br />
                저는 <span>다른 사람들이 직접 체감 할 수 있는 변화</span>를
                만들어가는 웹 개발자 박초혜 입니다.
                <br />
                스스로 강점과 부족한 점을 끊임없이 모니터링하며, 부족한 부분을
                개선해나가겠습니다.
                <br />
              </p>
            </div>
            <div className={styles.info}>
              <div
                className={`${styles.contact} ${styles.slideUp} ${
                  secondLoad ? styles.slideUpLoad : ''
                }`}
              >
                <p className={styles.contactTitle}>Contact</p>
                <ul className={styles.contactList}>
                  <li>
                    <i class='ri-github-fill'></i>
                    <a
                      href='https://github.com/ChohyePark/'
                      style={{ color: 'black' }}
                    >
                      {' '}
                      Github
                    </a>
                  </li>
                  <li>
                    <i className='ri-quill-pen-line'></i>
                    <a
                      href='https://sysoutctrlspace.tistory.com/'
                      style={{ color: 'black' }}
                    >
                      {' '}
                      Blog
                    </a>
                  </li>
                  <li>
                    <i className='ri-mail-line'></i>
                    <span> chohye0831@gmail.com</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section
          className={styles.designSection}
          ref={(el) => {
            scrollRef.current[1] = el;
          }}
        >
          <div
            className={`${styles.xLine} ${styles.line} ${
              load ? styles.load : ''
            }`}
          ></div>
        </section>
      </div>
    </>
  );
};

export default Introduction;
